import React from "react";
import { Target, ArrowRight } from "lucide-react";
import { categoryBudgetStatus } from "@/lib/insights";
import { formatCompact } from "@/lib/currency";

const BAR = { ok: "bg-emerald-500", warning: "bg-amber-500", danger: "bg-rose-500" };
const TEXT = { ok: "text-emerald-600", warning: "text-amber-600", danger: "text-rose-600" };

export function BudgetTargets({ finance, onSetup }) {
  const rows = categoryBudgetStatus(finance);

  return (
    <div className="rounded-3xl border border-zinc-200 bg-white p-5 shield-shadow" data-testid="budget-targets-card">
      <div className="mb-4 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Target className="h-4 w-4 text-zinc-400" />
          <p className="font-heading text-sm font-bold text-zinc-900">Target Hemat</p>
        </div>
        {rows.length > 0 && (
          <span className="text-[11px] text-zinc-400">Sisa {rows[0].daysRemaining} hari</span>
        )}
      </div>

      {rows.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-zinc-200 p-6 text-center" data-testid="budget-empty">
          <p className="text-sm text-zinc-400">Belum ada target kategori.</p>
          {onSetup && (
            <button
              data-testid="budget-empty-setup"
              onClick={onSetup}
              className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-emerald-600"
            >
              Atur target di Pengaturan Keuangan <ArrowRight className="h-4 w-4" />
            </button>
          )}
        </div>
      ) : (
        <div className="space-y-4" data-testid="budget-list">
          {rows.map((r) => {
            const truePct = Math.round(r.pctUsed * 100);
            const pct = Math.min(100, truePct);
            return (
              <div key={r.id} data-testid={`budget-row-${r.category}`}>
                <div className="mb-1.5 flex items-baseline justify-between">
                  <p className="font-heading text-sm font-bold text-zinc-900">{r.category}</p>
                  <p className="font-mono text-xs text-zinc-500">
                    <span className={TEXT[r.level]}>{formatCompact(r.used)}</span> / {formatCompact(r.target)}
                  </p>
                </div>
                <div className="h-2 w-full overflow-hidden rounded-full bg-zinc-100">
                  <div
                    className={`h-full rounded-full transition-all ${BAR[r.level]}`}
                    style={{ width: `${Math.max(pct, 3)}%` }}
                    data-testid={`budget-bar-${r.category}`}
                  />
                </div>
                <p className="mt-1.5 flex items-center justify-between text-[11px]">
                  <span className={`font-medium ${r.remaining >= 0 ? "text-zinc-500" : "text-rose-600"}`}>
                    {r.remaining >= 0 ? `Sisa ${formatCompact(r.remaining)}` : `Lewat ${formatCompact(-r.remaining)}`}
                  </span>
                  <span className="text-zinc-400">{truePct}% terpakai</span>
                </p>
                {r.level !== "ok" && (
                  <p className={`mt-1 text-xs leading-relaxed ${TEXT[r.level]}`} data-testid={`budget-msg-${r.category}`}>
                    {r.message}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
